<template>
  <div>
    <app-header title="合并账号协议" back-type="back-app" />
    <div class="container">
      <div class="title">用户手机绑定及账号合并协议</div>
      <div class="sub_title text_indedent">
        “友邻少年”官方平台及相关服务，系指北京每日友邻文化科技有限公司通过合法拥有并运营的、标注名称为“友邻少年”的客户端应用程序及网站（www.ylyk.com），向您（以下也称“用户”）提供的产品与服务，《用户手机绑定及账号合并协议》（以下称“本协议”）由您与北京每日友邻文化科技有限公司（以下称“本公司”）共同签订。
      </div>
      <p class="">一、手机绑定</p>
      <ul class="tip">
        <li class="">
          1、绑定手机号码：是指用户在申请注册友邻少年官方平台账户时或更新合并账号信息时设定的，用于包括但不限于接收由友邻少年官方平台的各种动态码、交易提醒短信等信息的手机号码。
        </li>
        <li>2、用户在绑定手机前，需确认待绑定手机处于通讯状态，能够及时接受讯息。</li>
        <li>3、手机绑定成功后，用户能够通过手机号码登录友邻少年官方平台学习。</li>
      </ul>
      <p>二、更新合并账号信息</p>
      <ul class="tip">
        <li>
          1、一个手机号码只能绑定一个友邻少年官方平台账号，如一个手机号码项下存在多个账号，为了更好的为用户服务，将提示用户合并账号，用户同意根据提示进行账户合并操作。
        </li>
        <li>2、合并内容包括但不仅限于：用户订单合并、个人信息合并、会员权益合并等账号相关信息。</li>
        <li>
          3、账号合并成功后，被合并账号将被作废，被合并的账号中的账号权益，订单信息将会同步到指定账号中，学习数据将会被永久清空且无法恢复。
        </li>
      </ul>
      <p>三、免责事由</p>
      <ul class="tip">
        <li>
          1、用户友邻少年官方平台账号信息及所绑定的手机号码由其自行设置并保管，友邻少年官方平台账号信息及手机绑定号码因非本平台原因泄露或遭受他人攻击、诈骗、偷窃等行为导致的损失及后果，均由用户自行承担。
        </li>
        <li>
          2、用户如果丢失手机或者绑定手机号码处于不能通讯状态，需立即与友邻少年官方平台取得联系，并及时更改手机绑定号码。若因用户自身原因而未及时更改，所造成的任何损失，由用户自行承担。
        </li>
        <li>
          3、友邻少年官方平台对用户的任何更改绑定号码请求采取行动均需要合理时间，除友邻少年官方平台存在过错外，友邻少年官方平台对在采取行动前已经产生的后果不承担任何责任。
        </li>
      </ul>
      <p>四、修改和解释权</p>
      <ul class="tip">
        <li>
          1、本平台有权单方随时修改或变更本协议内容，并通过平台公告变更后的协议文本，无需单独通知您。本协议进行任何修改或变更后，您还继续使用服务的，即代表您已阅读、了解并同意接受变更后的协议内容，且不得因此而要求任何补偿或赔偿；您如果不同意变更后的协议内容，可停止使用本公司所提供的服务。
        </li>
        <li>2、本公司保留对本协议条款、产品和服务以及本公司所提供的产品和服务的相关官方网站的最终解释权。</li>
      </ul>
      <p>五、争议解决</p>
      <ul class="tip">
        <li>1、本协议的订立、履行、解释及争议的解决均应适用中国法律。</li>
        <li>
          2、与本协议有关的一切争议，包括但不限于因本协议的签订或履行产生的争议、在本协议履行过程中产生的争议以及因本协议下产品和服务所产生的争议，均应以本公司所在地法院为第一审管辖法院。
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},

  methods: {}
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  padding-top: 0.48rem;
  padding-bottom: 100px;
  margin: 0 0.48rem;
  .title {
    font-size: 0.4rem;
    font-weight: 800;
    text-indent: 1cm;
    text-align: center;
    margin-bottom: 0.48rem;
  }
  .sub_title {
    text-indent: 1cm;
    line-height: 1.3;
    font-weight: 600;
    margin-bottom: 0.2rem;
  }
  p {
    text-indent: 1cm;
    font-weight: 600;
    margin-bottom: 0.2rem;
  }
  .tip {
    margin-bottom: 0.2rem;
    li {
      text-indent: 1cm;
      line-height: 1.3;
      font-size: 0.28rem;
      margin-bottom: 0.1rem;
    }
  }
}
</style>
